// extracted by mini-css-extract-plugin
export var headerCell = "_11-1";
export var loadingSpinnerContainer = "_11-4";
export var rowWrapper = "_11-3";
export var standaloneTable = "_11-5";
export var table = "_11-0";
export var white = "_11-2";